import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import Page from 'components/common/Page';
import { H2 } from '@montel/montelpro-shared-components-v2';
import { TopMenu } from 'components/common/Menu';
import menuConfig from './menuConfig';

const ToolsOutlet: FunctionComponent = () => (
	<Page>
		<H2 as={'h1'}>Tools</H2>
		<TopMenu menuConfig={menuConfig} maxElements={8} />
		<Outlet />
	</Page>
);

export default ToolsOutlet;
